module.exports = __webpack_public_path__ + "static/media/backArrow.37169357.svg";